export default (arrInputVazias) => {
    arrInputVazias.forEach(input => {
        input.style.borderColor = "red";
    });
}